<nz-upload nzListType="picture"
           [(nzFileList)]="fileList"
           [nzAccept]="nzAccept"
           [nzFileType]="nzAccept"
           [nzShowButton]="fileList.length < limit"
           [nzDisabled]="disableUpload"
           [nzBeforeUpload]="beforeUpload"
           [nzRemove]="removeFile">
      <button nz-button><i nz-icon nzType="upload"></i>Upload</button>
</nz-upload>
